import sileo from 'sileo';

const Tag = new sileo.Model('hqzen', 'tags');
const BoardTag = new sileo.Model('hqzen', 'board-tags');
const BoardAICategorizedTag = new sileo.Model('hqzen', 'board-ai-categorized-tags');

const actions = {
    createTag(context, data) {
        const form = new FormData();

        for (let key in data) {
            form.append(key, data[key]);
        }

        return Tag.objects.create(form)
            .then(response => response)
            .catch(error => error);
    },

    fetchWorkforceTags(context, filters) {
        return Tag.objects.filter(filters);
    },

    fetchTag(context, pk) {
        return Tag.objects.get(pk);
    },

    updateTag(context, { pk, data }) {
        const form = new FormData();

        for (let key in data) {
            form.append(key, data[key]);
        }
        return Tag.objects.update({ 'pk': pk }, form);
    },

    removeTag(context, filters) {
        return Tag.objects.delete(filters);
    },

    fetchBoardTags(context, filters) {
        return BoardTag.objects.filter(filters);
    },

    fetchBoardCategorizedTags(context, filters) {
        return BoardAICategorizedTag.objects.filter(filters);
    },
};

export default {
    namespaced: true,
    actions
};
